// Venda Nova e Migração saem do tipo da LINHA (faturamento_tipo), nunca da
// marcação do produto (Douglas 05/10/2026): o PASSAPORT é marcado venda nova e
// vendido como migração, e a mesma linha contava nas duas.
export function ehVendaNova(tipo: unknown): boolean {
  return String(tipo ?? '').trim().toUpperCase() === 'VENDA NOVA';
}

export function ehMigracao(tipo: unknown): boolean {
  return String(tipo ?? '').toUpperCase().includes('MIGRA');
}

// M2M é serviço único (Douglas 27/10/2026): a quantidade do item são as linhas de
// telemetria, que não contam como altas nem como migração; o faturamento conta.
const PRODUTOS_SEM_QUANTIDADE = ['M2M', 'M2M CPF'];

export function naoContaQuantidade(produto: unknown): boolean {
  return PRODUTOS_SEM_QUANTIDADE.includes(String(produto ?? '').trim().toUpperCase());
}
